/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SearchAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function SearchAction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Insurance/AddAction/Content/Content/Filter/SearchAction",
  onSubmit
  
}) {
let selectedSubmitData = fromData.useDataSubmit({ viewPath,
context: 'selected',
})
let selectedValueData = fromData.useDataFormat({ viewPath,
context: 'selected',
format: fromHelpers.isDisabled,
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 alignSelf="flex-end"
 data="selected"
 onClick={selectedSubmitData}
 marginBottom={0}
 data="selected"
 format="helpers.js isDisabled"
 disabled={selectedValueData}
 type="primary"
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Search"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}